import { takeLatest, put } from 'redux-saga/effects'

import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'

import r from 'reactotron-react-js'

const INITIAL_ROLE_MAN = makeKeys('INITIAL_ROLE_MAN')
const CREATE_USER = makeKeys('CREATE_USER')
const FETCH_ROLES = makeKeys('FETCH_ROLES')
const CREATE_ROLE = makeKeys('CREATE_ROLE')
const UPDATE_ROLE = makeKeys('UPDATE_ROLE')
const FETCH_USERS_ROLE = makeKeys('FETCH_USERS_ROLE')
const CREATE_USER_ROLE = makeKeys('CREATE_USER_ROLE')
const DELETE_USER_ROLE = makeKeys('DELETE_USER_ROLE')
const FETCH_PERMISSIONS = makeKeys('FETCH_PERMISSIONS')
const CREATE_PERMISSION = makeKeys('CREATE_PERMISSION')
const UPDATE_PERMISSION = makeKeys('UPDATE_PERMISSION')
const DELETE_PERMISSION = makeKeys('DELETE_PERMISSION')
const CREATE_PERMISSION_ROLE = makeKeys('CREATE_PERMISSION_ROLE')
const UPDATE_PERMISSION_ROLE = makeKeys('UPDATE_PERMISSION_ROLE')
const DELETE_PERMISSION_ROLE = makeKeys('DELETE_PERMISSION_ROLE')

const FETCH_MAIN_DEPARTMENTS = makeKeys('FETCH_MAIN_DEPARTMENTS')
const DELETE_SUB_DEPARTMENT = makeKeys('DELETE_SUB_DEPARTMENT')

const FETCH_DEPARTMENTS = makeKeys('FETCH_DEPARTMENTS')
const CREATE_DEPARTMENT = makeKeys('CREATE_DEPARTMENT')
const UPDATE_DEPARTMENT = makeKeys('UPDATE_DEPARTMENT')
// const DELETE_DEPARTMENT = makeKeys('DELETE_DEPARTMENT')

const FETCH_USER_DEPARTMENTS = makeKeys('FETCH_USER_DEPARTMENTS')
const CREATE_USER_DEPARTMENT = makeKeys('CREATE_USER_DEPARTMENT')
const UPDATE_USER_DEPARTMENT = makeKeys('UPDATE_USER_DEPARTMENT')
// const DELETE_USER_DEPARTMENT = makeKeys('DELETE_USER_DEPARTMENT')

const FETCH_PROJECT_USERS = makeKeys('FETCH_PROJECT_USERS')
const CREATE_PROJECT_USER = makeKeys('CREATE_PROJECT_USER')
const UPDATE_PROJECT_USER = makeKeys('UPDATE_PROJECT_USER')
const DELETE_PROJECT_USER = makeKeys('DELETE_PROJECT_USER')

export const initialRoleMan = makeAction(INITIAL_ROLE_MAN.REQUEST)
export const createUser = makeAction(CREATE_USER.REQUEST,'memberId','callBack','onDataCreated')
export const fetchRoles = makeAction(FETCH_ROLES.REQUEST,'onDataCreated','name')
export const createRole = makeAction(CREATE_ROLE.REQUEST,'data','callBack','onDataCreated')
export const updateRole = makeAction(UPDATE_ROLE.REQUEST,'data','callBack')
export const fetchUsersRole = makeAction(FETCH_USERS_ROLE.REQUEST,'onDataCreated','username')
export const createUserRole = makeAction(CREATE_USER_ROLE.REQUEST,'data','callBack')
export const deleteUserRole = makeAction(DELETE_USER_ROLE.REQUEST,'masterUserRoleId')
export const fetchPermissions = makeAction(FETCH_PERMISSIONS.REQUEST,'onDataCreated','name')
export const createPermission = makeAction(CREATE_PERMISSION.REQUEST,'data','callBack','onDataCreated')
export const updatePermission = makeAction(UPDATE_PERMISSION.REQUEST,'data','callBack')
export const deletePermission = makeAction(DELETE_PERMISSION.REQUEST,'permissionId','callBack')
export const createPermissionRole = makeAction(CREATE_PERMISSION_ROLE.REQUEST,'data','callBack')
export const updatePermissionRole = makeAction(UPDATE_PERMISSION_ROLE.REQUEST,'data','callBack')
export const deletePermissionRole = makeAction(DELETE_PERMISSION_ROLE.REQUEST,'data','callBack')

export const fetchUserDepartments = makeAction(FETCH_USER_DEPARTMENTS.REQUEST,'onDataCreated','username')
export const createUserDepartment = makeAction(CREATE_USER_DEPARTMENT.REQUEST,'data','callBack','onDataCreated')
export const updateUserDepartment = makeAction(UPDATE_USER_DEPARTMENT.REQUEST,'data','callBack')
// export const deleteUserDepartment = makeAction(DELETE_USER_DEPARTMENT.REQUEST,'','callBack')

// export const deleteDepartment = makeAction(DELETE_DEPARTMENT.REQUEST,'permissionId','callBack')
export const fetchDepartments = makeAction(FETCH_DEPARTMENTS.REQUEST)
export const createDepartment = makeAction(CREATE_DEPARTMENT.REQUEST,'data','callBack')
export const updateDepartment = makeAction(UPDATE_DEPARTMENT.REQUEST,'data','callBack')
// export const deleteDepartment = makeAction(DELETE_DEPARTMENT.REQUEST,'departmentId','callBack')
export const fetchMainDepartments = makeAction(FETCH_MAIN_DEPARTMENTS.REQUEST)
export const deleteSubDepartment = makeAction(DELETE_SUB_DEPARTMENT.REQUEST,'subDeptId')

export const fetchProjectUsers = makeAction(FETCH_PROJECT_USERS.REQUEST,'onDataCreated','projectName')
export const createProjectUser = makeAction(CREATE_PROJECT_USER.REQUEST,'data','callBack','onDataCreated')
export const updateProjectUser = makeAction(UPDATE_PROJECT_USER.REQUEST,'data','callBack')
export const deleteProjectUser = makeAction(DELETE_PROJECT_USER.REQUEST,'projectId')

const initialRoleManSuccess = makeAction(INITIAL_ROLE_MAN.SUCCESS)
const createUserSuccess = makeAction(CREATE_USER.SUCCESS)
const fetchRolesSuccess = makeAction(FETCH_ROLES.SUCCESS,'data')
const createRoleSuccess = makeAction(CREATE_ROLE.SUCCESS)
const updateRoleSuccess = makeAction(UPDATE_ROLE.SUCCESS)
const fetchRolesUpdate = makeAction(FETCH_ROLES.UPDATE,'data')
const fetchUsersRoleSuccess = makeAction(FETCH_USERS_ROLE.SUCCESS,'data')
const createUserRoleSuccess = makeAction(CREATE_USER_ROLE.SUCCESS)
const deleteUserRoleSuccess = makeAction(DELETE_USER_ROLE.SUCCESS)
const fetchUsersRoleUpdate = makeAction(FETCH_USERS_ROLE.UPDATE,'data')
const fetchPermissionsSuccess = makeAction(FETCH_PERMISSIONS.SUCCESS,'data')
const createPermissionSuccess = makeAction(CREATE_PERMISSION.SUCCESS)
const updatePermissionSuccess = makeAction(UPDATE_PERMISSION.SUCCESS)
const deletePermissionSuccess = makeAction(DELETE_PERMISSION.SUCCESS)
const createPermissionRoleSuccess = makeAction(CREATE_PERMISSION_ROLE.SUCCESS)
const updatePermissionRoleSuccess = makeAction(UPDATE_PERMISSION_ROLE.SUCCESS)
const deletePermissionRoleSuccess = makeAction(DELETE_PERMISSION_ROLE.SUCCESS)
const fetchPermissionsUpdate = makeAction(FETCH_PERMISSIONS.UPDATE,'data')

const fetchUserDepartmentsSuccess = makeAction(FETCH_USER_DEPARTMENTS.SUCCESS,'data')
const createUserDepartmentSuccess = makeAction(CREATE_USER_DEPARTMENT.SUCCESS)
const updateUserDepartmentSuccess = makeAction(UPDATE_USER_DEPARTMENT.SUCCESS)
const fetchUserDepartmentsUpdate = makeAction(FETCH_USER_DEPARTMENTS.UPDATE,'data')
// const deleteUserDepartmentSuccess = makeAction(DELETE_USER_DEPARTMENT.SUCCESS)

const fetchDepartmentsSuccess = makeAction(FETCH_DEPARTMENTS.SUCCESS,'data')
const fetchDepartmentsUpdate = makeAction(FETCH_DEPARTMENTS.UPDATE,'data')
const fetchMainDepartmentsSuccess = makeAction(FETCH_MAIN_DEPARTMENTS.SUCCESS,'data')
const fetchMainDepartmentsUpdate = makeAction(FETCH_MAIN_DEPARTMENTS.UPDATE,'data')

const deleteSubDepartmentSuccess = makeAction(DELETE_SUB_DEPARTMENT.SUCCESS)

const fetchProjectUsersSuccess = makeAction(FETCH_PROJECT_USERS.SUCCESS,'data')
const fetchProjectUsersUpdate = makeAction(FETCH_PROJECT_USERS.UPDATE,'data')
const createProjectUserSuccess = makeAction(CREATE_PROJECT_USER.SUCCESS)
const updateProjectUserSuccess = makeAction(UPDATE_PROJECT_USER.SUCCESS)
const deleteProjectUserSuccess = makeAction(DELETE_PROJECT_USER.SUCCESS)

const initial = {
  roles: [],
  usersRole: [],
  permissions: [],
  userDepartments: [],
  departments: [],
  mainDepartments: [],
  projectUsers: [],
  loading: false,
}
function* initialRoleManRequest() {
  try {
    yield put(appLoading())
    const roles = yield httpGet('admin/roles')
    if (roles.status === 200) {
      yield put(fetchRolesUpdate(roles.data))
    }
    const permissions = yield httpGet('admin/permissions')
    if (permissions.status === 200) {
      yield put(fetchPermissionsUpdate(permissions.data))
    }
    const usersRole = yield httpGet('admin/usersRole')
    if (usersRole.status === 200) {
      yield put(fetchUsersRoleUpdate(usersRole.data))
    }

    const userDepartments = yield httpGet('admin/userDepartmentAdjusts')
    if (userDepartments.status === 200) {
      yield put(fetchUserDepartmentsUpdate(userDepartments.data))
    }
    const departments = yield httpGet('members/departments')
    if (departments.status === 200) {
      yield put(fetchDepartmentsUpdate(departments.data))
    }

    const projectUsers = yield httpGet('admin/projectUsers')
    if (projectUsers.status === 200) {
      yield put(fetchProjectUsersUpdate(projectUsers.data))
    }

    yield put(initialRoleManSuccess())
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchRolesSuccess([]))
    yield put(initialRoleManSuccess())
  }
}

function* createUserRequest(action) {
  const { memberId, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost('admin/users', { memberId: memberId.id })
    yield put(appLoaded())
    if (response.status === 200) {
      // yield put(fetchUserDepartmentsSuccess(response.data))
      if (response.data.success === true) {
        yield put(fetchUsersRole(onDataCreated, memberId ? memberId.value : ''))
        yield put(createUserSuccess(response.data))
        yield put(toastSuccess('User Added'))
        callBack()
      } else {
        yield put(createUserSuccess(response.data))
        yield put(toastError('Add User Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(createUserSuccess())
    yield put(toastError('Add User Fail'))
  }
}

function* fetchRolesRequest(action) {
  const { onDataCreated, name } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('admin/roles')
    if (response.status === 200) {
      yield put(fetchRolesSuccess(response.data))
      if (onDataCreated) {
        let index = response.data.findIndex(d => d.name === name)
        onDataCreated(index > -1 ? index + 1 : 0)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchRolesSuccess([]))
  }
}

function* createRoleRequest(action) {
  const { data, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost(`admin/roles`, data)
    yield put(appLoaded())
    if (response.status === 200) {
      if (response.data.success === true) {
        yield put(fetchRoles(onDataCreated, data ? data.name : ''))
        yield put(createRoleSuccess())
        yield put(toastSuccess('Role Created'))
        callBack()
      } else {
        yield put(createRoleSuccess())
        yield put(toastError('Role Create Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(createRoleSuccess())
    yield put(toastError('Role Create Fail'))
  }
}

function* updateRoleRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPut(`admin/roles/${data.id}`, data)
    if (response.status === 200) {
      if (response.data.success === true) {
        const roles = yield httpGet('admin/roles')
        if (roles.status === 200) {
          yield put(fetchRolesUpdate(roles.data))
        }
        yield put(updateRoleSuccess())
        yield put(toastSuccess('Role Updated'))
      } else {
        yield put(updateRoleSuccess())
        yield put(toastError('Role Update Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(updateRoleSuccess())
    yield put(toastError('Role Update Fail'))
  }
}

function* fetchUsersRoleRequest(action) {
  const { onDataCreated, username } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('admin/usersRole')
    if (response.status === 200) {
      yield put(fetchUsersRoleSuccess(response.data))
      if (onDataCreated) {
        let index = response.data.findIndex(d => d.username === username)
        onDataCreated(index > -1 ? index + 1 : 0)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchUsersRoleSuccess([]))
  }
}

function* createUserRoleRequest(action) {
  const { data, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost(`admin/usersRole`, data)
    yield put(appLoaded())
    if (response.status === 200) {
      if (response.data.success === true) {
        yield put(fetchUsersRole(onDataCreated, data ? data.username : ''))
        yield put(createUserRoleSuccess())
        yield put(toastSuccess('Added Role To User'))
        callBack()
      } else {
        yield put(createUserRoleSuccess())
        yield put(toastError('Add Role Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(createUserRoleSuccess())
    yield put(toastError('Add Role Fail'))
  }
}

function* deleteUserRoleRequest(action) {
  const { masterUserRoleId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpDelete(`admin/usersRole/${masterUserRoleId}`)
    if (response.status === 200) {
      if (response.data.success === true) {
        const usersRole = yield httpGet('admin/usersRole')
        if (usersRole.status === 200) {
          yield put(fetchUsersRoleUpdate(usersRole.data))
        }
        yield put(deleteUserRoleSuccess())
        yield put(toastSuccess('Deleted Role Form User'))
      } else {
        yield put(deleteUserRoleSuccess())
        yield put(toastError('Delete Role Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(deleteUserRoleSuccess())
    yield put(toastError('Delete Role Fail'))
  }
}

function* fetchPermissionsRequest(action) {
  const { onDataCreated, name } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('admin/permissions')
    if (response.status === 200) {
      yield put(fetchPermissionsSuccess(response.data))
      if (onDataCreated) {
        let index = response.data.findIndex(d => d.name === name)
        onDataCreated(index > -1 ? index + 1 : 0)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchPermissionsSuccess([]))
  }
}

function* createPermissionsRequest(action) {
  const { data, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost(`admin/permissions`, data)
    yield put(appLoaded())
    if (response.status === 200) {
      if (response.data.success === true) {
        yield put(fetchPermissions(onDataCreated, data ? data.name : ''))
        yield put(createPermissionSuccess())
        yield put(toastSuccess('Permission Created'))
        callBack()
      } else {
        yield put(createPermissionSuccess())
        yield put(toastError('Permission Create Fail'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(createPermissionSuccess())
    yield put(toastError('Permission Create Fail'))
  }
}

function* updatePermissionsRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPut(`admin/permissions/${data.id}`, data)
    if (response.status === 200) {
      if (response.data.success === true) {
        const permissions = yield httpGet('admin/permissions')
        if (permissions.status === 200) {
          yield put(fetchPermissionsUpdate(permissions.data))
        }
        yield put(updatePermissionSuccess())
        yield put(toastSuccess('Permission Updated'))
      } else {
        yield put(updatePermissionSuccess())
        yield put(toastError('Permission Update Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(updatePermissionSuccess())
    yield put(toastError('Permission Update Fail'))
  }
}

function* deletePermissionsRequest(action) {
  const { permissionId, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpDelete(`admin/permissions/${permissionId}`)
    if (response.status === 200) {
      if (response.data.success === true) {
        const permissions = yield httpGet('admin/permissions')
        if (permissions.status === 200) {
          yield put(fetchPermissionsUpdate(permissions.data))
        }
        yield put(deletePermissionSuccess())
        yield put(toastSuccess('Permission Deleted'))
      } else {
        yield put(deletePermissionSuccess())
        yield put(toastError('Permission Delete Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(deletePermissionSuccess())
    yield put(toastError('Permission Delete Fail'))
  }
}

function* createPermissionsRoleRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPost(
      `admin/roles/${data.roleId}/permissions`,
      data
    )
    if (response.status === 200) {
      if (response.data.success === true) {
        const roles = yield httpGet('admin/roles')
        if (roles.status === 200) {
          yield put(fetchRolesUpdate(roles.data))
        }
        yield put(createPermissionRoleSuccess())
        yield put(toastSuccess('Added Permission Role'))
      } else {
        yield put(createPermissionRoleSuccess())
        yield put(toastError('Add Permission Role Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(createPermissionRoleSuccess())
    yield put(toastError('Add Permission Role Fail'))
  }
}

function* updatePermissionsRoleRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPut(
      `admin/roles/${data.roleId}/permissions/${data.id}`,
      data
    )
    if (response.status === 200) {
      if (response.data.success === true) {
        const roles = yield httpGet('admin/roles')
        if (roles.status === 200) {
          yield put(fetchRolesUpdate(roles.data))
        }
        yield put(updatePermissionRoleSuccess())
        yield put(toastSuccess('Updated Permission Role'))
      } else {
        yield put(updatePermissionRoleSuccess())
        yield put(toastError('Update Permission Role Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(updatePermissionRoleSuccess())
    yield put(toastError('Update Permission Role Fail'))
  }
}

function* deletePermissionsRoleRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpDelete(
      `admin/roles/${data.roleId}/permissions/${data.id}`
    )
    if (response.status === 200) {
      if (response.data.success === true) {
        const roles = yield httpGet('admin/roles')
        if (roles.status === 200) {
          yield put(fetchRolesUpdate(roles.data))
        }
        yield put(deletePermissionRoleSuccess())
        yield put(toastSuccess('Deleted Permission Role'))
      } else {
        yield put(deletePermissionRoleSuccess())
        yield put(toastError('Delete Permission Role Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(deletePermissionRoleSuccess())
    yield put(toastError('Delete Permission Role Fail'))
  }
}

function* fetchUserDepartmentsRequest(action) {
  const { onDataCreated, username } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('admin/userDepartmentAdjusts')
    if (response.status === 200) {
      yield put(fetchUserDepartmentsSuccess(response.data))
      if (onDataCreated) {
        let index = response.data.findIndex(d => d.username === username)
        onDataCreated(index > -1 ? index + 1 : 0)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchUserDepartmentsSuccess([]))
  }
}

function* createUserDepartmentsRequest(action) {
  const { data, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost(`admin/userDepartmentAdjusts`, data)
    yield put(appLoaded())
    if (response.status === 200) {
      if (response.data.success === true) {
        yield put(
          fetchUserDepartments(
            onDataCreated,
            data.length ? data[0].username : ''
          )
        )
        yield put(createUserDepartmentSuccess())
        yield put(toastSuccess('User Department Created'))
        callBack()
      } else {
        yield put(createUserDepartmentSuccess())
        yield put(toastError('User Department Create Fail'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(createUserDepartmentSuccess())
    yield put(toastError('USer Department Create Fail'))
  }
}

function* updateUserDepartmentsRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPut(
      `admin/userDepartmentAdjusts/${data.id}`,
      data
    )
    if (response.status === 200) {
      if (response.data.success === true) {
        const userDepartments = yield httpGet('admin/userDepartmentAdjusts')
        if (userDepartments.status === 200) {
          yield put(fetchUserDepartmentsUpdate(userDepartments.data))
        }
        yield put(updateUserDepartmentSuccess())
        yield put(toastSuccess('User Department Updated'))
      } else {
        yield put(updateUserDepartmentSuccess())
        yield put(toastError('User Department Update Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(updateUserDepartmentSuccess())
    yield put(toastError('User Department Update Fail'))
  }
}

function* deleteSubDepartmentRequest(action) {
  const { subDeptId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpDelete(
      `admin/userDepartmentAdjusts/${subDeptId}`
    )
    if (response.status === 200) {
      if (response.data.success === true) {
        const userDepartments = yield httpGet('admin/userDepartmentAdjusts')
        if (userDepartments.status === 200) {
          yield put(fetchUserDepartmentsUpdate(userDepartments.data))
        }
        yield put(deleteSubDepartmentSuccess())
        yield put(toastSuccess('Sub Department Deleted'))
      } else {
        yield put(deleteSubDepartmentSuccess())
        yield put(toastError('Sub Department Delete Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(deleteSubDepartmentSuccess())
    yield put(toastError('Sub Department Delete Fail'))
  }
}

function* fetchDepartmentsRequest() {
  try {
    // yield put(appLoading())
    const response = yield httpGet('members/departments')
    if (response.status === 200) {
      yield put(fetchDepartmentsSuccess(response.data))
    }
    // yield put(appLoaded())
  } catch (e) {
    // yield put(appLoaded())
    yield put(fetchDepartmentsSuccess([]))
  }
}

function* fetchMainDepartmentsRequest() {
  try {
    // yield put(appLoading())
    const response = yield httpGet('members/mainDepartments')
    if (response.status === 200) {
      yield put(fetchMainDepartmentsSuccess(response.data))
    }
    // yield put(appLoaded())
  } catch (e) {
    // yield put(appLoaded())
    yield put(fetchMainDepartmentsSuccess([]))
  }
}

function* fetchProjectUsersRequest(action) {
  const { onDataCreated, projectName } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('admin/projectUsers')
    if (response.status === 200) {
      yield put(fetchProjectUsersSuccess(response.data))
      if (onDataCreated) {
        let index = response.data.findIndex(d => d.projectName === projectName)
        onDataCreated(index > -1 ? index + 1 : 0)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchProjectUsersSuccess([]))
  }
}
function* createProjectUserRequest(action) {
  const { data, callBack, onDataCreated } = action.payload
  try {
    yield put(appLoading('Saving data.'))
    const response = yield httpPost(`admin/projectUsers`, data)
    yield put(appLoaded())
    if (response.status === 200) {
      if (response.data.success === true) {
        yield put(
          fetchProjectUsers(onDataCreated, data ? data.projectName : '')
        )
        yield put(createProjectUserSuccess())
        yield put(toastSuccess('Project User Created'))
        callBack()
      } else {
        yield put(createProjectUserSuccess())
        yield put(toastError('Project User Create Fail'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(createProjectUserSuccess())
    yield put(toastError('Project User Create Fail'))
  }
}

function* updateProjectUsersRequest(action) {
  const { data, callBack } = action.payload
  try {
    yield put(appLoading())
    callBack()
    const response = yield httpPut(`admin/projectUsers/${data.id}`, data)
    if (response.status === 200) {
      if (response.data.success === true) {
        const projectUsers = yield httpGet('admin/projectUsers')
        if (projectUsers.status === 200) {
          yield put(fetchProjectUsersUpdate(projectUsers.data))
        }
        yield put(updateProjectUserSuccess())
        yield put(toastSuccess('Project User Updated'))
      } else {
        yield put(updateProjectUserSuccess())
        yield put(toastError('Project User Update Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(updateProjectUserSuccess())
    yield put(toastError('Project User Update Fail'))
  }
}

function* deleteProjectUsersRequest(action) {
  const { projectId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpDelete(`admin/projectUsers/${projectId}`)
    if (response.status === 200) {
      if (response.data.success === true) {
        const projectUsers = yield httpGet('admin/projectUsers')
        if (projectUsers.status === 200) {
          yield put(fetchProjectUsersUpdate(projectUsers.data))
        }
        yield put(deleteProjectUserSuccess())
        yield put(toastSuccess('Project User Deleted'))
      } else {
        yield put(deleteProjectUserSuccess())
        yield put(toastError('Project User Delete Fail'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(deleteProjectUserSuccess())
    yield put(toastError('Project User Delete Fail'))
  }
}

export function* watchRoleManSaga() {
  yield takeLatest(INITIAL_ROLE_MAN.REQUEST, initialRoleManRequest)
  yield takeLatest(CREATE_USER.REQUEST, createUserRequest)
  yield takeLatest(FETCH_ROLES.REQUEST, fetchRolesRequest)
  yield takeLatest(CREATE_ROLE.REQUEST, createRoleRequest)
  yield takeLatest(UPDATE_ROLE.REQUEST, updateRoleRequest)
  yield takeLatest(FETCH_USERS_ROLE.REQUEST, fetchUsersRoleRequest)
  yield takeLatest(CREATE_USER_ROLE.REQUEST, createUserRoleRequest)
  yield takeLatest(DELETE_USER_ROLE.REQUEST, deleteUserRoleRequest)
  yield takeLatest(FETCH_PERMISSIONS.REQUEST, fetchPermissionsRequest)
  yield takeLatest(CREATE_PERMISSION.REQUEST, createPermissionsRequest)
  yield takeLatest(UPDATE_PERMISSION.REQUEST, updatePermissionsRequest)
  yield takeLatest(DELETE_PERMISSION.REQUEST, deletePermissionsRequest)
  yield takeLatest(CREATE_PERMISSION_ROLE.REQUEST, createPermissionsRoleRequest)
  yield takeLatest(UPDATE_PERMISSION_ROLE.REQUEST, updatePermissionsRoleRequest)
  yield takeLatest(DELETE_PERMISSION_ROLE.REQUEST, deletePermissionsRoleRequest)

  yield takeLatest(FETCH_USER_DEPARTMENTS.REQUEST, fetchUserDepartmentsRequest)
  yield takeLatest(CREATE_USER_DEPARTMENT.REQUEST, createUserDepartmentsRequest)
  yield takeLatest(UPDATE_USER_DEPARTMENT.REQUEST, updateUserDepartmentsRequest)

  yield takeLatest(DELETE_SUB_DEPARTMENT.REQUEST, deleteSubDepartmentRequest)

  yield takeLatest(FETCH_DEPARTMENTS.REQUEST, fetchDepartmentsRequest)
  yield takeLatest(FETCH_MAIN_DEPARTMENTS.REQUEST, fetchMainDepartmentsRequest)

  yield takeLatest(FETCH_PROJECT_USERS.REQUEST, fetchProjectUsersRequest)
  yield takeLatest(CREATE_PROJECT_USER.REQUEST, createProjectUserRequest)
  yield takeLatest(UPDATE_PROJECT_USER.REQUEST, updateProjectUsersRequest)
  yield takeLatest(DELETE_PROJECT_USER.REQUEST, deleteProjectUsersRequest)
}

export default createReducer(initial, state => ({
  [INITIAL_ROLE_MAN.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [INITIAL_ROLE_MAN.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [CREATE_USER.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_USER.SUCCESS]: data => ({
    ...state,
    loading: false,
  }),
  [FETCH_ROLES.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_ROLES.SUCCESS]: data => ({
    ...state,
    roles: data.data,
    loading: false,
  }),
  [FETCH_ROLES.UPDATE]: data => ({
    ...state,
    roles: data.data,
  }),
  [CREATE_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [FETCH_USERS_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_USERS_ROLE.SUCCESS]: data => ({
    ...state,
    usersRole: data.data,
    loading: false,
  }),
  [FETCH_USERS_ROLE.UPDATE]: data => ({
    ...state,
    usersRole: data.data,
  }),
  [CREATE_USER_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_USER_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [DELETE_USER_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [DELETE_USER_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [FETCH_PERMISSIONS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_PERMISSIONS.SUCCESS]: data => ({
    ...state,
    permissions: data.data,
    loading: false,
  }),
  [FETCH_PERMISSIONS.UPDATE]: data => ({
    ...state,
    permissions: data.data,
  }),
  [CREATE_PERMISSION.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_PERMISSION.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_PERMISSION.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_PERMISSION.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [CREATE_PERMISSION_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_PERMISSION_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_PERMISSION_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_PERMISSION_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [DELETE_PERMISSION_ROLE.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [DELETE_PERMISSION_ROLE.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [FETCH_USER_DEPARTMENTS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_USER_DEPARTMENTS.SUCCESS]: data => ({
    ...state,
    userDepartments: data.data,
    loading: false,
  }),
  [FETCH_USER_DEPARTMENTS.UPDATE]: data => ({
    ...state,
    userDepartments: data.data,
  }),
  [CREATE_USER_DEPARTMENT.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_USER_DEPARTMENT.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_USER_DEPARTMENT.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_USER_DEPARTMENT.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [DELETE_SUB_DEPARTMENT.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [DELETE_SUB_DEPARTMENT.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [FETCH_MAIN_DEPARTMENTS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_MAIN_DEPARTMENTS.SUCCESS]: data => ({
    ...state,
    mainDepartments: data.data,
    loading: false,
  }),
  [FETCH_DEPARTMENTS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_DEPARTMENTS.SUCCESS]: data => ({
    ...state,
    departments: data.data,
    loading: false,
  }),
  [FETCH_PROJECT_USERS.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [FETCH_PROJECT_USERS.SUCCESS]: data => ({
    ...state,
    projectUsers: data.data,
    loading: false,
  }),
  [FETCH_PROJECT_USERS.UPDATE]: data => ({
    ...state,
    projectUsers: data.data,
  }),
  [CREATE_PROJECT_USER.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [CREATE_PROJECT_USER.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [UPDATE_PROJECT_USER.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [UPDATE_PROJECT_USER.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
  [DELETE_PROJECT_USER.REQUEST]: () => ({
    ...state,
    loading: true,
  }),
  [DELETE_PROJECT_USER.SUCCESS]: () => ({
    ...state,
    loading: false,
  }),
}))
